class TopButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-trigger-top-button]');
    this.scrollThreshold = parseInt(this.dataset.showAfterScroll) || 300;
    this.isVisible = false;
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.scrollToTop.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    this.handleScroll();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.scrollToTop.bind(this));
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    
    if (scrollTop > this.scrollThreshold) {
      if (!this.isVisible) {
        this.classList.add('is-visible');
        this.isVisible = true;
      }
    } else {
      if (this.isVisible) {
        this.classList.remove('is-visible');
        this.isVisible = false;
      }
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('top-button', TopButton);
